export const TEXTS = {
  DRAFT_ERROR_MESSAGE: "Failed to submit the draft.",
  DRAFT_SUCCESS_MESSAGE: "The draft has been submitted.",
  VALIDATION_ERROR_MESSAGE:
    "In the form, some values are missing or invalid. Please correct them and try again.",
  SUBMIT_ERROR_MESSAGE: "Failed to submit the form.",
  SUBMIT_SUCCESS_MESSAGE: "The form has been submitted.",
  SUBMIT_RETRY_MESSAGE: "Please resubmit the form.",
};
